import { render, staticRenderFns } from "./MyHistory.vue?vue&type=template&id=4fd2017e&scoped=true"
import script from "./MyHistory.vue?vue&type=script&lang=js"
export * from "./MyHistory.vue?vue&type=script&lang=js"
import style0 from "./MyHistory.vue?vue&type=style&index=0&id=4fd2017e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd2017e",
  null
  
)

export default component.exports